import React from "react";
import { useState } from "react";
import Moment from "moment/moment";
import { auth } from "../services/auth";
import { updateItem, fetchItem } from "../services/itemsPreview";
import styles from "../css/items.module.css";

export function ItemsPreview({ closePopup, popupData, handleRefresh }) {
  const [inputs, setInputs] = useState(popupData);

  const token = auth().getToken();

  const itemConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const handleChange = (event) => {
    const name = event.target.name;
    let value = event.target.value;
    if (event.target.type === "checkbox") {
      if (event.target.checked) {
        value = true;
      } else {
        value = false;
      }
    }
    if (event.target.type === "number") {
      value = parseFloat(event.target.value);
    }
    setInputs({ ...inputs, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    return updateItem(inputs, itemConfig).then((response) => {
      if (response.ok) {
        handleRefresh(true);
        closePopup();
      }
      return response.json();
    });
  };

  const fetchItems = (event) => {
    event.preventDefault();
    if (
      window.confirm(
        "Are you sure you wanna fetch the items? It may result with rewriting of changed/updated fields."
      )
    ) {
      return fetchItem(itemConfig);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col">
      <div className="flex flex-col justify-center center content-center gap-5 ">
        <div className="flex flex-col lg:flex-row justify-around">
          <div className="flex flex-col ">
            <p>
              <label className="uppercase font-semibold" htmlFor="panelId">
                Panel Id
              </label>
            </p>
            <input
              className={`${styles.panelIdInputField}`}
              type="number"
              value={popupData.panelId || ""}
              disabled
              onChange={handleChange}
              name="panelId"
              id="panelId"
              required
            />
          </div>
          <div className="flex flex-col w-80 "></div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="serviceId">
                Service Id
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="number"
              defaultValue={popupData.serviceId || ""}
              onChange={handleChange}
              name="serviceId"
              id="serviceId"
              required
            />
          </div>
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="seoExpertServiceId">
                SEO Service Id
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="text"
              defaultValue={popupData.seoExpertServiceId || ""}
              onChange={handleChange}
              name="seoExpertServiceId"
              id="seoExpertServiceId"
              required
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="name">
                Name
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="text"
              defaultValue={popupData.name || ""}
              onChange={handleChange}
              name="name"
              id="name"
              required
            />
          </div>
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="seoExpertName">
                SEO Name
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="text"
              defaultValue={popupData.seoExpertName || ""}
              onChange={handleChange}
              name="seoExpertName"
              id="seoExpertName"
              required
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="rate">
                Rate
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="number"
              defaultValue={popupData.rate || ""}
              onChange={handleChange}
              name="rate"
              id="rate"
              required
            />
          </div>
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="seoExpertRate">
                SEO Rate
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="number"
              defaultValue={popupData.seoExpertRate || ""}
              onChange={handleChange}
              name="seoExpertRate"
              id="seoExpertRate"
              required
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="min">
                Min
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="number"
              defaultValue={popupData.min || ""}
              onChange={handleChange}
              name="min"
              id="min"
              required
            />
          </div>
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="seoExpertMin">
                SEO Min
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="number"
              defaultValue={popupData.seoExpertMin || ""}
              onChange={handleChange}
              name="seoExpertMin"
              id="seoExpertMin"
              required
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="max">
                Max
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="number"
              defaultValue={popupData.max || ""}
              onChange={handleChange}
              name="max"
              id="max"
              required
            />
          </div>
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="seoExpertMax">
                SEO Max
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="number"
              defaultValue={popupData.seoExpertMax || ""}
              onChange={handleChange}
              name="seoExpertMax"
              id="seoExpertMax"
              required
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="service">
                Service
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="text"
              defaultValue={popupData.service || ""}
              onChange={handleChange}
              name="service"
              id="service"
              required
            />
          </div>
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="seoExpertService">
                SEO Service
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="text"
              defaultValue={popupData.seoExpertService || ""}
              onChange={handleChange}
              name="seoExpertService"
              id="seoExpertService"
              required
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div className="flex flex-col ">
            <p>
              <label className="uppercase font-semibold" htmlFor="type">
                Type
              </label>
            </p>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="text"
              defaultValue={popupData.type || ""}
              onChange={handleChange}
              name="type"
              id="type"
              required
            />
          </div>
          <div className="flex flex-col w-80 "></div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="description">
                Description
              </label>
            </p>
            <input
              className={`${styles.descriptionInputField} outline-transition ease-in-out outline-0`}
              type="textarea"
              defaultValue={popupData.description || ""}
              onChange={handleChange}
              name="description"
              id="description"
              required
            />
          </div>
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="seoExpertDescription">
                SEO Description
              </label>
            </p>
            <input
              className={`${styles.descriptionInputField} outline-transition ease-in-out outline-0`}
              type="textarea"
              defaultValue={popupData.seoExpertDescription || ""}
              onChange={handleChange}
              name="seoExpertDescription"
              id="seoExpertDescription"
              required
            />
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-around">
          <div className="flex flex-col ">
            <p>
              <label className="uppercase font-semibold" htmlFor="comment">
                Comment
              </label>
            </p>
            <input
              className={`${styles.descriptionInputField} outline-transition ease-in-out outline-0`}
              type="textarea"
              defaultValue={popupData.comment || ""}
              onChange={handleChange}
              name="comment"
              id="comment"
            />
          </div>
          <div className="flex flex-col w-80 "></div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div className="flex flex-col ">
            <p>
              <label className="uppercase font-semibold" htmlFor="created">
                Created
              </label>
            </p>
            <input
              className={`${styles.fetchedInputField}`}
              type="text"
              value={Moment(popupData.created).format("YYYY-MM-DD") || ""}
              disabled
              onChange={handleChange}
              name="created"
              id="created"
              required
            />
          </div>
          <div className="flex flex-col w-80 "></div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div className="flex flex-col ">
            <p>
              <label className="uppercase font-semibold" htmlFor="modified">
                Modified
              </label>
            </p>
            <input
              className={`${styles.fetchedInputField}`}
              disabled
              type="text"
              value={Moment(popupData.modified).format("YYYY-MM-DD") || ""}
              onChange={handleChange}
              name="modified"
              id="modified"
              required
            />
          </div>
          <div className="flex flex-col w-80 "></div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div className="flex flex-col ">
            <p>
              <label className="uppercase font-semibold" htmlFor="dateTimeArchived">
                Archived
              </label>
            </p>
            <input
              className={`${styles.fetchedInputField}`}
              disabled
              type="text"
              value={Moment(popupData.dateTimeArchived).format("YYYY-MM-DD") || ""}
              onChange={handleChange}
              name="dateTimeArchived"
              id="dateTimeArchived"
              required
            />
          </div>
          <div className="flex flex-col w-80 "></div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div className="flex flex-col ">
            <p>
              <label className="uppercase font-semibold" htmlFor="dateTimeFetched">
                Fetched
              </label>
            </p>
            <input
              className={`${styles.fetchedInputField}`}
              disabled
              type="text"
              value={Moment(popupData.dateTimeFetched).format("YYYY-MM-DD") || ""}
              onChange={handleChange}
              name="dateTimeFetched"
              id="dateTimeFetched"
              required
            />
          </div>
          <div className="flex flex-col w-80 "></div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around">
          <div className="flex flex-col ">
            <label className="uppercase font-semibold" htmlFor="setArchived">
              Set Archived
            </label>
            <input
              className={`${styles.itemsPreviewInputField}`}
              type="checkbox"
              defaultChecked={popupData.dateTimeArchived != null ? true : false}
              defaultValue={popupData.setArchived}
              onChange={handleChange}
              name="setArchived"
              id="setArchived"
            />
          </div>
          <div className="flex flex-col w-80 "></div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around items-center">
          <div className="flex flex-col ">
            <label className="uppercase font-semibold" htmlFor="useSEOExpert">
              Use Dailysocialboost Settings
            </label>
            <input
              className={`${styles.settingsInputField}`}
              type="checkbox"
              defaultChecked={popupData.useSEOExpert}
              defaultValue={popupData.useSEOExpert}
              onChange={handleChange}
              name="useSEOExpert"
              id="useSEOExpert"
            />
          </div>
          <div className="flex flex-col w-80 "></div>
        </div>
        <div className="flex flex-col lg:flex-row justify-around items-center">
          <button className={`${styles.itemPreviewBtn}`} onClick={closePopup}>
            Close
          </button>
          <button className={`${styles.itemPreviewBtn}`} type="submit" value="Submit">
            Submit
          </button>
        </div>
      </div>
      <button
        className="text-center my-2 px-20 py-3 w-64 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
        onClick={fetchItems}
      >
        Fetch
      </button>
    </form>
  );
}

export default ItemsPreview;
